// extracted by mini-css-extract-plugin
module.exports = {"label":"FormSectionTitle_label__ustNI","subtitle":"FormSectionTitle_subtitle__ElDzV"};